import { useContext } from 'react';

import { breadcrumbsContext } from '../Breadcrumbs/BreadcrumbsContext';

export function useBreadcrumbs() {
  const context = useContext(breadcrumbsContext);

  if (typeof context === 'undefined') {
    throw new Error('useBreadcrumbs must be within BreadcrumbsProvider');
  }

  return context;
}
